// One upload limit for every file people attach (requests, quotes, invoices, delivery notes,
// receipts, supplier documents, bank letters): 2 MB each (Fahad, 2 Nov; D112). Keeps SharePoint
// storage and the Functions request size small; the voucher pack (pack.ts) has its own limit.
export const MAX_UPLOAD_MB = 2;
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;
